import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><path d=\"M597.333333 768h170.666667v-221.866667l-256-256-256 256V768h170.666667v-170.666667h170.666666v170.666667z m298.666667-213.333333h-42.666667v298.666666H170.666667v-298.666666H128l384-384 384 384z\" p-id=\"23380\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol